module.exports = __webpack_public_path__ + "static/media/Free-tagIcon.e4f311bd.png";